var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.146 20.024V2.464C13.31 1.975 14 1 15.463 1h5.244c.529.244 1.586.878 1.586 1.463 0 .732-.366.976-1.586.976h-5.244v3.17h3.903c.447.162 1.341.683 1.341 1.463 0 .78-.894 1.3-1.341 1.464h-3.903v10.487c1.505.529 4.513 2.293 4.513 5.122 0 3.537-2.927 5.854-5.488 5.854C11.927 31 9 29.293 9 25.146c0-3.317 2.764-4.796 4.146-5.122zm1.22 8.293a2.927 2.927 0 1 0 0-5.854 2.927 2.927 0 0 0 0 5.854z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/KEY.278bdad33dd0d692e227c10ce01474cb.svg";
export { ForwardRef as ReactComponent };